import logo64 from '../assets/clarity-csm-logo-64.png';
import logo96 from '../assets/clarity-csm-logo-96.png';
import logo128 from '../assets/clarity-csm-logo-128.png';
import logo256 from '../assets/clarity-csm-logo-256.png';

// Single source of truth for the Clarity CSM brand mark — used in the
// sidebar, auth pages, loading screen, etc. To refresh the brand asset,
// replace src/assets/clarity-csm-logo-master.png and re-run the resize
// script described in that folder, then this component picks it up
// everywhere automatically.
const SRC_SET = `${logo64} 64w, ${logo96} 96w, ${logo128} 128w, ${logo256} 256w`;

export const BrandLogo = ({ size = 40, className = '', ...rest }) => (
  <img
    src={logo128}
    srcSet={SRC_SET}
    sizes={`${size}px`}
    width={size}
    height={size}
    alt="Clarity CSM"
    data-testid="brand-logo"
    className={`object-contain select-none ${className}`}
    draggable={false}
    {...rest}
  />
);

export default BrandLogo;
